import React, { useEffect } from "react";
import Header from "../components/Header/Header";

type Props = {};

const CancellationPolicy = (props: Props) => {
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const userToken: string = currentUser?.jwtToken;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="h-[75px] z-10 fixed mx-10 ">
        <Header position={"fixed"} isLoggedIn={userToken ? true : false} />
      </div>
      <div className={` rounded-[8px] border-2  lg:mx-[50px] m-[20px] lg:mx-8 mx-2 p-[20px] lg:p-[32px] ${window.location.pathname==='/profile/cancellation-policy' ? '': 'mt-[100px]'} `}>
        <div className="text-[#434343] font-medium text-[30px] mb-2">
          SPOT FINDER CANCELLATION POLICY
        </div>
        <div className="border-2 rounded-lg p-5">
          <p className="mt-4 font-bold text-center text-[20px]">
            CANCELLATION POLICY
          </p>
          <p className="mt-4 ">
            This Cancellation policy shall be binding and applicable to all
            transactions that takes place via –www.spotfinder.app and/or the
            mobile application.
          </p>
          <ol className="list-decimal mt-4 ml-4">
            <li className="mt-4">
              <p className="font-bold ml-4">
                Booking not yet approved by owner.
              </p>
              <p className="mt-4">
                The Driver must cancel his reservation by cancelling through the{" "}
                <b>SPOT FINDER </b>website. When the Driver makes a cancellation
                request for his booking, notice of cancellation is regarded to
                have been received.<b>SPOT FINDER</b> is not liable for any
                communication problems.
              </p>
            </li>

            <li className="mt-4">
              <p className="font-bold ml-4">Booking after approved by owner.</p>
              <p className="mt-4">
                By entering into the website and cancelling in the driver's
                dashboard, the Driver may obtain a full refund for any
                transaction, minus the service charge. You will be refunded if
                you cancel 24 hours before your arrival date.
              </p>
              <p className="mt-4">
                Drivers can also contact <b>[contact@spotfinder.app]</b> by email.
                A cancellation made less than 24 hours before the arrival date
                will not be reimbursed.{" "}
              </p>
              <p className="mt-4">
                If the Driver fails to cancel the booking through the Spot
                finder cancellation method, the Driver will be responsible for
                the full amount of the costs owed to the Owner and will not be
                entitled to any reimbursement.
              </p>
              <p className="mt-4">
                If there are unusual circumstances beyond the Driver's
                reasonable control and the Driver no longer requires the Parking
                Space, the Driver may seek an exceptional cancellation and
                obtain a reimbursement. The Driver must notify Spot Finder of
                any unusual conditions before the Rental Period begins. The
                Driver and Owner agree that whether or not a cancellation is due
                to extraordinary circumstances and whether or not a refund is
                necessary is at the exclusive discretion of Spot finder, who
                will decide on the amount of the refund (if any), and each party
                agrees that Spot finder's decision is binding.
              </p>
              <p className="mt-4">
                If the Owner is forced to cancel the Driver's reservation owing
                to extraordinary circumstances beyond the Owner's reasonable
                control, the Owner commits to notify Spot finder. The parties
                agree that Spot finder will be instructed to contact the Driver
                and provide acceptable alternative parking spot offered by
                another registered Spot finder owner. Spot finder makes no
                guarantees or warranties that alternative parking can be found
                and accepts no liability arising from the failure of the Owner
                or the Driver to honor the booking, or for the costs of
                alternative parking or other costs arising directly or
                indirectly as a result of any breach of any term of this
                Agreement.
              </p>
              <p className="mt-4">
                The Owner agrees that if they need to cancel a Driver's booking
                and the circumstances are not exceptional or not beyond the
                Owner's reasonable control the Driver will be entitled to a full
                refund including the service fee (if a suitable alternative
                cannot be arranged by Spot finder) and the Owner also agrees to
                cover any additional cost which is payable by the Driver for
                suitable alternative parking arrangements (up to a maximum of
                $______ per day if the Parking Space.
              </p>
              <p className="mt-4">
                The Driver and the Owner agree that whether an Owner
                cancellation is due to exceptional circumstances beyond the
                Owner's reasonable control, and whether the Owner is responsible
                for the Driver's additional costs, will be determined solely at
                the discretion of Spot finder, who will decide on the amount of
                compensation (if any), and each party agrees that Spot finder's
                decision will be binding.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;
